var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-checkbox"},[_c('Checkbox',_vm._g(_vm._b({},'Checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }